import { render, staticRenderFns } from "./GroupsDetails.vue?vue&type=template&id=56562b9d"
import script from "./GroupsDetails.vue?vue&type=script&lang=js"
export * from "./GroupsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports